import type { Ticket, User } from '@vd/types';
import { isExternalSource } from './SourceBadge';

/**
 * Who filed a ticket, when a teammate did, for the Session window's
 * "Reported by …, a team member" (board ticket t--4ugrP). A visitor's report
 * (the widget, a report link) names its reporter itself, and a ticket made
 * for one names a stand-in creator, so neither gives a name here.
 */
export function teamReporterName(ticket: Ticket | undefined, members: Array<{ user: User }> | undefined): string | null {
  if (!ticket || isExternalSource(ticket.source)) return null;
  return members?.find((member) => member.user.id === ticket.createdBy)?.user.name?.trim() || null;
}
